import React, { SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { Container, Item, dropdown } from './styles';
import { IconDropdown } from '../Icons';
import { TooltipHowItWorks } from './components/TooltipHowItWorks';
import { Typography } from '@utex/ui-kit';

import { ViewType } from '../../types';

export interface NavigationProps {
  activeItem?: 'ideas' | 'portfolio' | 'howItWorks';
  view: ViewType;
  onIdeasClick: () => void;
  onPortfolioClick: () => void;
  onIPOClick: () => void;
  onPreIPOClick: () => void;
}

export function Navigation(props: NavigationProps) {
  const { t } = useTranslation('header');
  const { view, activeItem, onIdeasClick, onPortfolioClick, onIPOClick, onPreIPOClick } = props;

  return (
    <>
      <Container>
        <Item
          href="/investments"
          view={view}
          isActive={activeItem === 'ideas'}
          onClick={(e: SyntheticEvent) => {
            e.preventDefault();
            onIdeasClick();
          }}
          data-testid="menu-link-investment-ideas"
        >
          {t('Invest Ideas')}
        </Item>

        <Item
          href="/investments/open-investment"
          view={view}
          isActive={activeItem === 'portfolio'}
          onClick={(e: SyntheticEvent) => {
            e.preventDefault();
            onPortfolioClick();
          }}
          data-testid="menu-link-my-portfolio"
        >
          <Typography.Text>{t('Portfolio')}</Typography.Text>
        </Item>
        <TooltipHowItWorks
          onIPOClick={onIPOClick}
          onPreIPOClick={onPreIPOClick}
          trigger={
            <Item
              as="button"
              type="button"
              view={view}
              isActive={activeItem === 'howItWorks'}
              data-testid="menu-link-how-it-works"
            >
              <Typography.Text>{t('How It Works')}</Typography.Text>
              <IconDropdown width={11} height={20} css={dropdown} />
            </Item>
          }
        />
      </Container>
    </>
  );
}
